import { Checkbox, Inline, RadioGroup, ValidationMessage, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { useTranslation, useValidation, useProperty } from '@eti/providers';
import { Field as ReduxFormField } from 'redux-form';
import { screenReaderOnly } from '../../../common/utils/styles';
import { stylesVariables } from '../../utils/utils';
import SelectionOption from './SelectionOption';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const {
  colors: {
    divider: BorderColor
  }
} = vars;
const {
  firstColumnWidth
} = stylesVariables;
const selectionRow = css`
  border: 1px solid ${BorderColor};
  border-radius: 0 0 3px 3px;
  display: flex;
  flex-direction: row;
`;
const errorMessagStyles = css`
  margin-inline-start: 0;
  margin-top: 10px;
`;
const firstColumnStyles = css`
  padding: 16px;
  width: ${firstColumnWidth};
`;
const RadioGroupComponent = _ref => {
  let {
    discountPercentageTitle,
    emptyOptionId,
    emptyOptionTitle,
    footerWrapperStyles,
    handleChange,
    input,
    meta,
    name,
    priceText,
    sellableOptions,
    shouldShowPricePerPerson,
    travelers
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    p
  } = useProperty();
  const shouldUseValidation = p('IbeClient.TravelerDetails.OptionalProductsRequireValidation.Enabled');
  const hasError = Boolean(meta.touched && meta.error) || Boolean(meta.touched && input.value === undefined);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(RadioGroup, {
      hasError: shouldUseValidation ? hasError : false,
      name: "value",
      onChange: handleChange,
      selectedValue: input.value,
      children: [/*#__PURE__*/_jsx(RadioGroup.Legend, {
        className: screenReaderOnly,
        children: `${discountPercentageTitle} ${t('Product.Bundle.SelectOne.Label.required')} ${t('Validation.Required')}`
      }), /*#__PURE__*/_jsxs("div", {
        className: selectionRow,
        children: [/*#__PURE__*/_jsxs("div", {
          className: firstColumnStyles,
          children: [shouldUseValidation ? t('Product.Bundle.SelectOne.Label.required') : '', shouldUseValidation && hasError && /*#__PURE__*/_jsx(ValidationMessage, {
            className: errorMessagStyles,
            "data-testid": "ancillaryBundle-validation-message",
            role: "alert",
            variant: "error",
            children: t('Validation.ProductSection.SelectOption')
          })]
        }), sellableOptions.map(option => /*#__PURE__*/_jsx(SelectionOption, {
          name: name,
          numberOfTravelers: travelers.filter(traveler => traveler.ageType !== 'INF').length,
          option: option,
          priceText: priceText,
          shouldShowPricePerPerson: shouldShowPricePerPerson
        }, option.id))]
      })]
    }), /*#__PURE__*/_jsxs(Inline, {
      align: "end",
      className: footerWrapperStyles,
      noWrap: true,
      children: [/*#__PURE__*/_jsxs(Checkbox.Label, {
        htmlFor: `choice.${name}.${emptyOptionId}`,
        children: [emptyOptionTitle, /*#__PURE__*/_jsx("span", {
          className: screenReaderOnly,
          children: t('ScreenReader.Product.Bundle.Empty.Option.Text')
        })]
      }), /*#__PURE__*/_jsx(Checkbox, {
        "aria-checked": Boolean(input.value === emptyOptionId),
        checked: input.value === emptyOptionId,
        "data-testid": `productBundleItem-${emptyOptionId}`,
        id: `choice.${name}.${emptyOptionId}`,
        onChange: handleChange,
        value: emptyOptionId
      })]
    })]
  });
};
const hasBeenSelected = value => value !== null && value !== undefined;
const BundleSelection = _ref2 => {
  let {
    name,
    ...props
  } = _ref2;
  const validate = useValidation(name);
  const format = value => {
    return hasBeenSelected(value === null || value === void 0 ? void 0 : value.value) ? value === null || value === void 0 ? void 0 : value.value.id : undefined;
  };
  return /*#__PURE__*/_jsx(ReduxFormField, {
    component: RadioGroupComponent,
    format: format,
    name: name,
    props: {
      ...props,
      name
    },
    validate: validate
  });
};
export default BundleSelection;
//# sourceMappingURL=BundleSelection.js.map